import KLogin from './KLogin.vue'
import KLogout from './KLogout.vue'
import KRegister from './KRegister.vue'
import KResetPassword from './KResetPassword.vue'
import KChangeEndpoint from './KChangeEndpoint.vue'

export {
  KLogin,
  KLogout,
  KRegister,
  KResetPassword,
  KChangeEndpoint
}
